import {
  ALLOWED_MEDIA,
  type SizesString,
} from '@/app/components/media/app-image';

export const SPARTAN_LINEUP_MODEL_CARD_IMAGE_SIZE = {
  width: 640,
  height: 360,
} as const;

export const getSpartanLineupModelCardResponsiveSources = (src: string) =>
  ({
    mobileSrc: {
      src,
      media: ALLOWED_MEDIA.xsDown,
      sizes:
        '(min-width: 360px) 376px, calc(100vw - 48px)' satisfies SizesString,
      widths: [640, 750, 828, 1080],
    },
    desktopSrc: {
      src,
      media: ALLOWED_MEDIA.xsUp,
      sizes: '376px',
      widths: [828],
    },
  }) as const;
